export default {
    hero: {
        title: 'Ben je gewoon moe of ben je misschien wel te moe? Doe de test.',
    },
    intro: {
        title: 'Iedereen is wel eens moe. Veel mensen zijn elke dag moe. Maar na een nacht slapen of na even rust is het vaak weer over.',
        text: 'Sommige mensen blijven langer moe. Je bent dan niet per se chronisch moe. Bij ongeveer 85 van de 100 mensen is de moeheid binnen een paar weken of een paar maanden weer over. <br/><br/>Wil je weten hoe ernstig jouw vermoeidheidsklachten zijn? Tips hoe je met vermoeidheid om kunt gaan? Advies voor een eventuele behandeling? Test jezelf hier.',
        card1: {
            title: 'Test je zelf. Makkelijk en veilig.',
            text: 'Wil je weten of je chronisch moe bent? Deze test brengt snel je vermoeidheidsklachten in kaart. Daarnaast krijg je advies hoe je het beste met je vermoeidheid om kunt gaan.',
        },
        card2: {
            title: 'Moe na behandeling van kanker.',
            text: `
            <div>
            Is je vermoeidheid begonnen in de periode dat je behandeld werd voor kanker? Op <a class="text-white font-weight-bold text-underline" href="/kanker">deze website</a> vind je een test die speciaal ontwikkeld voor vermoeidheid na kanker.
            </div>`,
        },
    },
    slider: {
        title: 'Ervaringen van anderen',
        text: 'Hoe ervaren anderen hun vermoeidheid en hoe gaan ze ermee om? Misschien herken je jezelf in een van de verhalen die je hier leest.',
        nextStory: 'Naar het volgende verhaal',
    },
};